import React__default, { useRef, useContext } from 'react';
import { u as useCustomReducer } from './useCustomReducer-8da85d66.esm.js';

const init = {
  state: {},
  dispatch: (a, p) => {},
  eventManager: {}
};
const AppContext = /*#__PURE__*/React__default.createContext(init);
// new line custom hook

const AppProvider = _ref => {
  let {
    children,
    initialState,
    appReducer,
    envConfig,
    user,
    isWebSocketEnabled
  } = _ref;
  const [state, dispatch] = useCustomReducer(appReducer, initialState, envConfig.REACT_APP_ENV === "dev");
  // const { getCurrentAuthenticatedUser } = useAuth();
  const eventManager = useRef();
  const _dispatch = (a, p) => {
    dispatch({
      type: a,
      payload: p
    });
  };
  return /*#__PURE__*/React__default.createElement(AppContext.Provider, {
    value: {
      state: state,
      dispatch: _dispatch,
      eventManager: eventManager === null || eventManager === void 0 ? void 0 : eventManager.current
    }
  }, children);
};
const useAppStateManager = () => {
  const {
    state,
    dispatch,
    eventManager
  } = useContext(AppContext);
  return {
    state,
    dispatch,
    eventManager
  };
};
AppProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppProvider"
};

export { AppProvider as A, useAppStateManager as u };
